import { getDefaultExportFromCjs } from "./_commonjsHelpers.js";
import { __require as requirePostcssJs } from "../node_modules/.pnpm/postcss-js@4.1.0_postcss@8.5.8/node_modules/postcss-js/index2.js";
var postcssJsExports = requirePostcssJs();
const index = /* @__PURE__ */ getDefaultExportFromCjs(postcssJsExports);
export {
  index as default
};
//# sourceMappingURL=index2.js.map
